






















































import sizeMixin from '@/product/mixins/sizeMixin'

import ModalFullScreen from '@/common/components/ModalFullScreen.vue'
import SizeInput from '@/common/components/SizeInput.vue'
import SizeInputError from '@/common/components/SizeInputError.vue'
import SizeInputRequest from '@/product/components/SizeInputRequest.vue'
import ModalSizeInput from '@/product/components/ModalSizeInput.vue'
import { Button } from '@raksul/raksul-common-ui'

import { sizeInputError } from '@/common/utils/common'
import { SkuSize } from '@/product/types'

export default sizeMixin.extend({
  components: {
    ModalFullScreen,
    SizeInputRequest,
    Button,
    SizeInput,
    SizeInputError,
    ModalSizeInput
  },
  data(): {
    showModal: boolean
  } {
    return {
      showModal: false
    }
  },
  computed: {
    displaySizes(): string {
      return this.sizes
        .filter((size: SkuSize) => size.quantity > 0)
        .map((size: SkuSize) => `${size.name}: ${size.quantity}`)
        .join(' / ')
    },
    printableSkuId(): string {
      return this.$_storeState.productDetail.printableSkuId
    },
    disabled(): boolean {
      return this.$_storeState.productLoading
    },
    hasAdditionalOptions(): boolean {
      return this.$_storeState.productDetail.product.hasOptions
    }
  },
  methods: {
    sizeInputError,
    openSizeInputModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    onSubmitSizeInput(sizes: Array<SkuSize>) {
      this.showModal = false
      if (sizes) this.sizes = sizes
      this.$store.commit('setValidQuantity', true)
      this.$_onChangeSizeInput()
    }
  }
})
